module.exports = __webpack_public_path__ + "img/1465270516.ece9ec50.jpg";